/**
 * AcademicTransfer E-Learning Constants
 * Centralized configuration values and magic strings
 */

const Constants = {
  // ==========================================
  // Storage Keys
  // ==========================================
  STORAGE: {
    PROGRESS: 'at-elearning-progress',
    TOKEN: 'at-elearning-token',
    CONFIG: 'at-elearning-config',
    SELECTED_ORG: 'at-elearning-selected-org',
    CELEBRATED_MILESTONES: 'at-elearning-celebrated-milestones',
    LANGUAGE: 'at-elearning-language'
  },

  // ==========================================
  // Error Messages (User-Friendly)
  // ==========================================
  ERROR_MESSAGES: {
    400: 'Invalid request. Please check your input and try again.',
    401: 'Your session has expired. Please log in again.',
    403: "You don't have permission to do that.",
    404: "We couldn't find what you're looking for.",
    408: 'Request timeout. Please check your connection and try again.',
    429: 'Too many requests. Please try again in a few minutes.',
    500: 'Something went wrong on our end. Please try again later.',
    502: 'Service temporarily unavailable. Please try again later.',
    503: 'Service under maintenance. Please try again later.',
    NETWORK: 'No internet connection. Please check your network.',
    UNKNOWN: 'An unexpected error occurred. Please try again.'
  }
};

// Make available globally
window.Constants = Constants;

// Node.js (testing)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = Constants;
}
